export default __webpack_public_path__ + "static/media/Teyanna.5e7543b7.jpg";